import type { AgencySubscription, Subscription } from "common/types";

import { formatBillingDate } from "../../utils";
import SubscriptionInfo from "../SubscriptionInfo";
import PlanSettingsDetailsPanel from "./PlanSettingsDetailsPanel";

import type { ReactNode } from "react";

interface SubscriptionBillingPanelProps {
  cardLabel: string;
  nextBilling?: number;
  priceComponent?: ReactNode;
  subscription: Subscription | AgencySubscription | undefined;
  cancelledAt?: number;
}

export default function SubscriptionBillingPanel({
  cardLabel,
  nextBilling,
  priceComponent,
  subscription,
  cancelledAt,
}: SubscriptionBillingPanelProps) {
  const { status } = subscription;
  const isScheduledCancellation = status === "non_renewing";
  const showEndState = isScheduledCancellation && cancelledAt;
  const dateLabel = showEndState ? "Ends on" : "Renews on";

  return (
    <PlanSettingsDetailsPanel className="p-5 gap-3">
      <div className="flex flex-row justify-between gap-4 items-start">
        <div className="flex flex flex-col gap-4">
          <span className="text-xs-medium text-black-500">{cardLabel}</span>

          <div className="flex flex-col gap-1">
            <span className="text-xxs text-black-500">{dateLabel}</span>

            <span className="text-xs-bold">
              {formatBillingDate(
                (isScheduledCancellation ? cancelledAt : nextBilling) * 1000,
              )}
            </span>
          </div>
        </div>

        {priceComponent}
      </div>

      <div className="border-t-2 border-dotted border-black-200" />

      <div className="flex flex-col gap-4">
        <span className="text-xs-medium text-black-500">Payment</span>

        <SubscriptionInfo isLoading={false} subscription={subscription} />
      </div>
    </PlanSettingsDetailsPanel>
  );
}
